// MP402 — One support address, one source.
//
// Before this file the address was a literal in apps/web's SignupPage
// and in the api's OpenAPI contact block, the Settings page linked
// sales@ for upgrades, and the marketing Contact page told customers
// to "use the in-product help center" — which had no support link.
// Every surface now imports from here; the api additionally accepts a
// SUPPORT_EMAIL env override (apps/api/src/config.ts) and serves the
// resolved value at GET /v1/public/support so non-workspace clients
// (marketing site, status page, future mobile) never hardcode it.
//
// The mailbox itself is an operator decision still pending for the
// beta (see docs/ops-manual/beta-support-runbook.md). Changing the
// default here is the only code change that decision needs.
export const SUPPORT_EMAIL = 'support@ferrytic.com';
/** MP407 — one sales address, one source. Before this the launcher's
 *  locked-app tiles linked a `.test` placeholder, the Settings plan
 *  card linked this address as a literal, and the marketing Contact
 *  page defaulted to a different domain. Same domain as support, per
 *  the plan card (the only surface that had it right). The marketing
 *  site may still override it with `VITE_SALES_EMAIL`. */
export const SALES_EMAIL = 'sales@ferrytic.com';
/** MP411 — one security / DSAR-erasure address, one source. Before
 *  this it was a literal in the api's DSAR export notes (routes/me.ts)
 *  and the Profile page's failed-deletion hint; SECURITY.md and the
 *  compliance policies name the same mailbox. Same domain as support
 *  and sales — deliberately NOT derived from `BRAND_DOMAIN`
 *  (hosts.ts), because the security intake is a commitment made in
 *  public documents and must not move when the brand domain does. */
export const SECURITY_EMAIL = 'security@ferrytic.com';
/** `mailto:` href for a sales link. `subject` is encoded here so a
 *  caller never hand-builds a query string. */
export function salesMailto(subject, email) {
    const to = email && email.trim() ? email.trim() : SALES_EMAIL;
    return subject && subject.trim() ? `mailto:${to}?subject=${encodeURIComponent(subject.trim())}` : `mailto:${to}`;
}
/** Prefix every prefilled support subject starts with, so the mailbox
 *  can filter product-originated mail from the rest. */
export const SUPPORT_SUBJECT_PREFIX = '[X-One support]';
/** Builds the prefilled subject line. Deliberately carries nothing
 *  beyond topic + org slug + page path: no email, no name, no uid. */
export function supportSubject(parts = {}) {
    const segments = [SUPPORT_SUBJECT_PREFIX];
    if (parts.topic)
        segments.push(parts.topic.trim());
    if (parts.orgSlug)
        segments.push(`org:${parts.orgSlug.trim()}`);
    if (parts.pagePath)
        segments.push(`page:${stripQuery(parts.pagePath)}`);
    return segments.join(' ');
}
/** `mailto:` href for a support link. `email` defaults to the shared
 *  constant; pass the value from GET /v1/public/support when a surface
 *  has fetched it. */
export function supportMailto(parts = {}) {
    const to = parts.email && parts.email.trim() ? parts.email.trim() : SUPPORT_EMAIL;
    return `mailto:${to}?subject=${encodeURIComponent(supportSubject(parts))}`;
}
function stripQuery(path) {
    const q = path.indexOf('?');
    const h = path.indexOf('#');
    const cut = [q, h].filter((i) => i >= 0);
    return (cut.length ? path.slice(0, Math.min(...cut)) : path).trim();
}
//# sourceMappingURL=support.js.map